import docImg from './imgs/file-alt-solid.png';

function Document({title, filepath}) {
    return (
        <a className="document-container" href={process.env.PUBLIC_URL + filepath} target="_blank" rel="noreferrer noopener">
            <img src={docImg} alt=""/>
            <p>{title}</p>
        </a>
    );
}

export default Document;
